//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { SliderProps } from 'react-aria-components';
import styled from 'styled-components';

import { SubsectionText } from '@components/atoms/text/Text';
import { Slider } from '@components/primitives/slider/Slider';
import { TrackingIdPrefix } from '@models/TrackingId';
import { readableDurationFromSeconds } from '@utils/readableNumber';

export const UIACustomCoverSelectionSlider = ({
  defaultValue,
  framesPerSecond,
  maxValue,
  onChange,
  trackingIdPrefix,
  value,
}: SliderProps & {
  framesPerSecond: number;
  trackingIdPrefix: TrackingIdPrefix;
}) => {
  return (
    <StyledSlider
      defaultValue={defaultValue}
      maxValue={maxValue}
      onChange={onChange}
      step={1 / framesPerSecond}
      value={value}
    >
      <Slider.Track>
        <Slider.Thumb
          ariaLabel={'Video Timestamp Slider Selector'}
          index={0}
          trackingIdPrefix={trackingIdPrefix}
        />
      </Slider.Track>
      <Wrapper>
        <Slider.Label>
          <StyledSliderOutput>
            {({ state }) => (
              <SubsectionText>
                {`${readableDurationFromSeconds(+state.getThumbValueLabel(0))}/${readableDurationFromSeconds(maxValue ?? 0)}`}
              </SubsectionText>
            )}
          </StyledSliderOutput>
        </Slider.Label>
      </Wrapper>
    </StyledSlider>
  );
};

const StyledSlider = styled(Slider)(
  ({ theme }) => `
  width: 100%;
  margin: ${theme.spacings[3]} 0 0 ${theme.spacings[1]};
`,
);

const Wrapper = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${theme.spacings[2]};
`,
);

const StyledSliderOutput = styled(Slider.Output)(
  ({ theme }) => `
    margin-left: -${theme.spacings[1]};
  `,
);
